/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatCategoryColumn.vue?vue&type=template&id=0555c843"
import script from "./ChatCategoryColumn.vue?vue&type=script&lang=js"
export * from "./ChatCategoryColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0555c843')) {
      api.createRecord('0555c843', component.options)
    } else {
      api.reload('0555c843', component.options)
    }
    module.hot.accept("./ChatCategoryColumn.vue?vue&type=template&id=0555c843", function () {
      api.rerender('0555c843', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatCategoryColumn.vue"
export default component.exports